import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, LinearProgress, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'
import useStyles from './styles'

const ImportProgressAlert = ({
  governanceProjectImport,
  governanceProjectId,
  onRetry,
}) => {
  const [loading, setLoading] = useState(false)
  const snackbar = useSnackbar()
  const classes = useStyles()

  if (!governanceProjectImport) return null

  const {
    status,
    progress,
    processedEvidencesCount,
    totalActivities,
    errorMessage,
  } = governanceProjectImport

  if (status === 'completed') return null

  const {
    IMPORT_STATUS_LABEL,
    IMPORT_STATUS_SEVERITY,
    IMPORT_IN_PROGRESS_STATUSES,
    IMPORT_RETRYABLE_STATUSES,
  } = constants.governanceProject

  const severity = IMPORT_STATUS_SEVERITY[status] || 'info'
  const label = IMPORT_STATUS_LABEL[status] || status
  const isInProgress = IMPORT_IN_PROGRESS_STATUSES.includes(status)
  const isRetryable = IMPORT_RETRYABLE_STATUSES.includes(status)

  const handleRetry = async () => {
    try {
      setLoading(true)
      await service.dponet.governanceProject.retryImport({
        governanceProjectId,
      })
      onRetry()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error, false),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Alert
      severity={severity}
      className={classes.alert}
      action={
        isRetryable ? (
          <Button
            color="inherit"
            size="small"
            onClick={handleRetry}
            disabled={loading}
          >
            Reprocessar
          </Button>
        ) : null
      }
    >
      <Typography variant="subtitle2">{label}</Typography>
      {isInProgress && (
        <Box>
          <LinearProgress
            variant="determinate"
            value={progress || 0}
            className={classes.progressBar}
          />
          <Typography variant="caption" className={classes.counter}>
            {processedEvidencesCount}/{totalActivities} atividades processadas
          </Typography>
        </Box>
      )}
      {isRetryable && errorMessage && (
        <Typography variant="body2">{errorMessage}</Typography>
      )}
    </Alert>
  )
}

ImportProgressAlert.propTypes = {
  governanceProjectImport: PropTypes.object,
  governanceProjectId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onRetry: PropTypes.func.isRequired,
}

export default ImportProgressAlert
